import ShippingDeliveryPolicy from "./shipping-delivery-policy.page";

export default ShippingDeliveryPolicy;
